import { useEffect } from "react";

const useClearSensitiveDataFromStorage = () => {
  useEffect(() => {
    try {
      const localStorageFields = JSON.parse(localStorage.getItem("onBoarding")) ?? [];

      if (localStorageFields.length) {
        const sensitiveFields = ["email", "password", "password_confirmation"];
        const updatedFields = localStorageFields.filter(
          (field) => !sensitiveFields.includes(field[0]),
        );
        localStorage.setItem("onBoarding", JSON.stringify(updatedFields));
      }
      // eslint-disable-next-line no-unused-vars -- surfaced by ESLint 10 migration, flagged for follow-up
    } catch (e) {
      // no op unable to read/write to localStorage
    }
  }, []);
};

export default useClearSensitiveDataFromStorage;
